import React from 'react';
import { Create } from 'react-admin';
import { getTransform } from '../rateSettingsTransform';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';

const MarketLocationTypePositionRateSettingCreate = () => (
  <Create
    transform={getTransform(
      ['market_id', 'location_type_id'],
      'market_location_type_position_rate_setting',
    )}
  >
    <PositionRateSettingsForm settingsField="market_location_type_position_rate_setting" />
  </Create>
);

export default MarketLocationTypePositionRateSettingCreate;
